import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.2rem;
`;

const NotFoundView = () => {

  return (
      <NotFoundContainer>
        <Helmet>
          <title>페이지를 찾을 수 없습니다</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <Title>404 - 페이지를 찾을 수 없습니다.</Title>
        <Message>요청하신 페이지가 존재하지 않습니다.</Message>
      </NotFoundContainer>
  );
};

export default NotFoundView;
